<template>
  <div class="contentbox">
    <div class="toptitle">
        <span class="return">
          <router-link tag="span" to="/">&lt;</router-link>
        </span>
      Registration
    </div>
    <div class="contenttitle">
      <div class="title">
        <!--<p>-->
          <!--<span class="font20">Hi,</span>-->
          <!--<span>Welcome to Tesco World</span>-->
        <!--</p>-->
        <!--<p>歡迎來到Tesco平臺</p>-->
      </div>
      <div class="switch_but">
        <!--<el-button @click="switch_register_class(0)" v-show="registerdata.users_role === 2" type="primary">Supplier</el-button>-->
        <!--<el-button @click="switch_register_class(1)" v-show="registerdata.users_role === 0" type="primary">Staff</el-button>-->
        <el-button v-show="registerdata.users_role === 1" type="primary">Customer</el-button>
      </div>
    </div>
    <div class="registerbox">
      <!--<div class="register">-->
        <!--<img src="../assets/images/com.png" alt="">-->
        <!--<input v-model="registerdata.enterprise" disabled="true" type="text" placeholder="輸入企業名稱">-->
      <!--</div>-->
      <div class="itme_box">
        <div class="register address">
          <p>+ {{registerdata.region}}</p>
          <router-link class="minbut" tag="span" to="/selectareacode">Change Location</router-link>
        </div>
        <div class="register">
          <img src="../assets/images/phone.png" alt="">
          <input v-model="$store.state.loginphone" type="number" placeholder="Mobile no:">
        </div>
      </div>
      <div class="itme_box">
        <div class="register">
          <img src="../assets/images/clinic.png" alt="">
          <input v-model="registerdata.clinic" placeholder="Clinci Name">
        </div>
        <div class="register">
          <img src="../assets/images/code.png" alt="">
          <input v-model="registerdata.smsCode" type="number" placeholder="Authentication code:">
          <span @click="getvalcode" class="minbut">{{valuecodemeassage}}</span>
        </div>
      </div>
      <div class="itme_box">
        <div class="register">
          <img src="../assets/images/user.png" alt="">
          <input v-model="registerdata.dentist_mame" placeholder="Dentist Name">
        </div>
        <div class="register">
          <img src="../assets/images/fax.png" alt="">
          <input v-model="registerdata.fax" placeholder="Fax">
        </div>
      </div>
      <div class="itme_box">
        <div class="register">
          <img src="../assets/images/user.png" alt="">
          <input v-model="registerdata.username" type="text" placeholder="Register Email">
        </div>
        <div class="register">
          <select placeholder="Register Email" @change="change_province('province')" v-model="province">
            <option value="0">Province</option>
            <option v-for="time in province_list"
                    :key="time.address_id"
                    :value="time">{{time.address_name}}</option>
          </select>
          <select placeholder="Register Email" @change="change_province('city')" v-model="city">
            <option value="0">City</option>
            <option v-for="time in city_list" :key="time.address_id" :value="time">{{time.address_name}}</option>
          </select>
          <select placeholder="Register Email" v-model="district">
            <option value="0">Area</option>
            <option v-for="time in district_list" :key="time.address_id" :value="time">{{time.address_name}}</option>
          </select>
        </div>
      </div>
      <div class="itme_box">
        <div class="register">
          <img src="../assets/images/tel.png" alt="">
          <input v-model="registerdata.tel" placeholder="Tel">
        </div>
        <div class="register">
          <img src="../assets/images/address.png" alt="">
          <input v-model="registerdata.detailed_address" placeholder="Clinci Address">
        </div>
      </div>
      <!--<div class="itme_box" v-show="register_class === 2">-->
        <!--<div class="register">-->
          <!--<img src="../assets/images/staff.png" alt="">-->
          <!--<input v-model="registerdata.technician_name" placeholder="技術員名稱">-->
        <!--</div>-->
        <!--<div class="register">-->
          <!--<img src="../assets/images/working_years.png" alt="">-->
          <!--<input v-model="registerdata.technician_seniority" placeholder="技術員年資">-->
        <!--</div>-->
      <!--</div>-->
      <div class="itme_box">
        <!--<div class="register">-->
          <!--<img src="../assets/images/mail.png" alt="">-->
          <!--<input v-model="registerdata.email" type="email" placeholder="Email">-->
        <!--</div>-->
        <div class="register">
          <img src="../assets/images/password.png" alt="">
          <input v-model="registerdata.password" type="password" placeholder="Password">
        </div>
      </div>

    </div>
    <div class="butbox">
      <div @click="submission" class="but">Submit</div>
      <div class="other">
        <span class="red">Register means you agree the Terms & Conditions</span>
      </div>
    </div>
  </div>

</template>

<script>
  import { MessageBox } from 'mint-ui';
  import {ecstsendPhoneCode,ecstregisterForm,getaddress} from '../assets/js/api'
    export default {
        name: "sellerregister",
        data(){
          return {
            valuecodemeassage:'Send authentication code',
            registerdata:{
              enterprise:'Tesco',
              username:'',
              clinic:'', //诊所名称
              dentist_mame:'', //醫生名称
              fax:'', //传真
              tel:'', //电话
              address:'', //地址
              detailed_address:'', //地址
              phone:this.$store.state.loginphone,
              smsCode:'',
              region:this.$store.state.phoneCode,
              technician_name:"",
              technician_seniority:"",
              email:'',
              password:'',
              users_role:1
            },

            province_list:[], //省
            city_list:[], //市
            district_list:[], //區

            province:'0', //省
            city:'0', //市
            district:'0', //區
          }
        },
        components:{
          MessageBox
        },
        mounted(){
          if (this.$store.state.phoneCode === ''){
            getCode().then((data)=>{
              // this.$store.commit('set_phoneCode',data.map(itme=>itme.region_num)[0])
              this.$store.commit('set_phoneCode',data.map(data[0].region_num))
              this.region = this.$store.state.phoneCode
            })
          }
          // 獲取省份
          getaddress().then(data=>{
            if (data.status){
              this.province_list = data.data
            }
            console.log(data)
          })
        },
        methods:{
          change_province(flage){
            // 切換省份
            if (flage === "province"){
              // 獲取城市
              if (this.province === '0'){
                this.city_list = []
              }
              else {
                getaddress(this.province.address_id).then(data=>{
                  if (data.status){
                    this.city_list = data.data
                  }
                  else {
                    this.city_list = []
                  }
                })
              }
              this.district_list = []
            }

            // 切換城市
            if (flage === "city"){
              // 獲取地區
              if (this.city === '0'){
                this.district_list = []
              }
              else {
                getaddress(this.city.address_id).then(data=>{
                  if (data.status){
                    this.district_list = data.data
                  }
                  else {
                    this.district_list = []
                  }
                })
              }
            }
          },
          switch_register_class(users_role){
            this.registerdata.users_role = users_role
          },
          getvalcode(){
            if (this.$store.state.loginphone === ''){
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message: '請填寫手機號碼',
                  confirmButtonText:"確定",
                })
              }
              else {
                this.$alert('請填寫手機號碼', '提示', {
                  confirmButtonText: '确定',
                });
              }
              return
            }
            if (this.valuecodemeassage !== 'Send authentication code') return
            let ecstsendPhoneCodedata={
              region:this.$store.state.phoneCode,
              phone:this.$store.state.loginphone
            }
            ecstsendPhoneCode(ecstsendPhoneCodedata).then(data=>{
              console.log(data)

              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message:  data.message,
                  confirmButtonText:"确定",
                })
              }
              else {
                this.$alert(data.message, '提示', {
                  confirmButtonText: '确定',
                });
              }
              if (data.status){
                let i=60;
                let setIntervalid = setInterval(()=>{
                  this.valuecodemeassage = '('+i+')s'
                  i--;
                  if (i===0) {
                    clearInterval(setIntervalid)
                    this.valuecodemeassage = 'Send authentication code'
                  }
                },1000)
              }
            }).catch(ree=>{
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message:  ree.message,
                  confirmButtonText:"确定",
                })
              }
              else {
                this.$alert(ree.message, '提示', {
                  confirmButtonText: '确定',
                });
              }

            })
          },
          submission(){
            let state = true
            let message = ''

            if (this.registerdata.enterprise === ''){
              message='請填寫企業名稱'
              state = false
            }
            else if (this.$store.state.loginphone === ''){
              message='請填寫手機號碼'
              state = false
            }
            else if (this.registerdata.clinic === ''){
              message='請填寫診所名稱'
              state = false
            }
            else if (this.registerdata.smsCode === ''){
              message='請填寫驗證碼'
              state = false
            }
            else if (this.registerdata.username === ''){
              message='請填寫用戶名稱'
              state = false
            }
            // else if (this.registerdata.fax === ''){
            //   message='請填寫傳真'
            //   state = false
            // }
            else if (this.province === '0'){
              message = '請選擇省份'
              state = false
            }
            else if (this.city === '0'){
              message = '請選擇城市'
              state = false
            }
            // else if (this.district === '0'){
            //   message = '請選擇地區'
            //   state = false
            // }
            else if (this.registerdata.tel === ''){
              message='請填寫電話'
              state = false
            }
            else if (this.registerdata.detailed_address === ''){
              message='請填寫地址'
              state = false
            }
            // else if (this.registerdata.technician_name === '' && this.registerdata.users_role === 2){
            //   message='請填寫技術員名稱'
            //   state = false
            // }
            // else if (this.registerdata.technician_seniority === '' && this.registerdata.users_role === 2){
            //   message='請填寫技術員年資'
            //   state = false
            // }
            // else if (this.registerdata.email === ''){
            //   message='請填寫郵箱'
            //   state = false
            // }
            else if (this.registerdata.password === ''){
              message='請填寫密碼'
              state = false
            }
            if (state) {
              this.registerdata.phone = this.$store.state.loginphone
              // 拼接地址
              this.registerdata.address = this.province.address_name + this.city.address_name + this.district.address_name + this.registerdata.detailed_address
              this.registerdata.email = this.registerdata.username

              console.log(this.registerdata)

              ecstregisterForm(this.registerdata).then(data=>{
                if (this.$store.state.client){
                  MessageBox({
                    title: '提示',
                    showCancelButton: false,
                    message: data.message || data.data || data.msg,
                    confirmButtonText:"确定",
                  }).then(res=>{
                    if (data.status) {
                      this.$router.push({ path: '/'});
                    }
                  })
                }
                else {
                  this.$alert(data.message || data.data || data.msg, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      if (data.status) {
                        this.$router.push({ path: '/'});
                      }
                    }
                  });
                }

              })
            }
            else {
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  showCancelButton: false,
                  message: message,
                  confirmButtonText:"确定",
                })
              }
              else {
                this.$alert(message, '提示', {
                  confirmButtonText: '确定',
                });
              }

            }
          }
        }
    }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
  .contentbox {
    width: 100%;
    .toptitle{
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      position: relative;
      .return{
        font-size: 40px;
        position: absolute;
        left: 0.2rem;
        cursor: pointer;
      }
    }
    .contenttitle{
      width: 90%;
      margin: 20px auto 60px auto;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .font20{
        font-size: 30px;
      }
    }
    .registerbox{
      width: 80%;
      margin: 0 auto;
      @media (min-width: @screen-xs-max) {
        width: 60%;
      }
      .itme_box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div{
          width: 48%;
        }
      }
      .register{
        display: flex;
        justify-content: space-between;
        position: relative;
        margin: 20px 0;
        img{
          position: absolute;
          width: 26px;
          height: 32px;
          bottom: 10px;
        }
        input,select{
          border: none;
          font-size: 0.3rem;
          border-bottom: 1px solid #e8e8e8;
          width: 85%;
          /*margin-left: 10%;*/
          padding-left: 15%;
          height: 36px;
          color: #7c7c7c;
          &:focus{
            border-color: #22bb61;
          }
          &::placeholder{
            color: #7c7c7c;
          }
        }
        select{
          width: 30%;
          padding: 0;
        }
        .minbut{
          display: block;
          padding: 5px 10px;
          position: absolute;
          border: 1px solid #979797;
          border-radius: 23px;
          right: 0;
          top: 0;
          cursor: pointer;
        }
      }
      .address{
        display: flex;
        align-items: center;
        height: 26px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e8e8e8;
        p{
          font-size: 0.3rem;
          width: 100%;
          padding-left: 0;
        }
      }
    }
    .butbox{
      width: 80%;
      margin: 20px auto;
      @media (min-width: @screen-xs-max) {
        width: 30%;
      }
      .but{
        text-align: center;
        padding: 16px 0;
        background-color: #979797;
        color: #353535;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .other{
        .red{
          color: #ef3f46;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sellerregister.vue